import { useQuery } from "react-query";
import { RestError } from "../../services/rest-service/RestService";
import { IUICustomizationSettingsDTO } from "../../services/ui-customization-data-service/Models";
import UICustomizationDataService from "../../services/ui-customization-data-service/UICustomizationDataService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { keys } from "./Keys";

export type UIEffectiveCustomizationSettingsQueryParameters = {
    userID: number;
} & BaseUseQueryParameters<IUICustomizationSettingsDTO | undefined>

export function useUIEffectiveCustomizationSettings({
    userID,
    enabled,
    onError,
    onSuccess
}: UIEffectiveCustomizationSettingsQueryParameters) {
    return useQuery<IUICustomizationSettingsDTO | undefined, RestError>(
        keys.userEffectiveSettings(userID),
        ({ signal }) => {
            return UICustomizationDataService.getEffectiveUICustomizationSettings(userID, signal);
        },
        {
            enabled: enabled,
            onError: onError,
            onSuccess: onSuccess
        }
    );
}